module.exports = __webpack_public_path__ + "static/level-3-card.f1ecf25d.png";